import * as yup from 'yup';
import * as ERRORS from '../../constants/errors';
import { PHONE_REGEX } from '../../utils/regex';

export const signalProblemSchema = yup
  .object()
  .shape({
    reason: yup
      .string()
      .required(ERRORS.DESCRIPTION_IS_REQUIRED)
      .max(300, ERRORS.DESCRIPTION_IS_TOO_LONG_300),
  })
  .required();

export const contactUsSchema = yup
  .object()
  .shape({
    name: yup.string().required(ERRORS.NAME_IS_REQUIRED),
    surname: yup.string().required(ERRORS.SURNAME_IS_REQUIRED),
    email: yup
      .string()
      .email(ERRORS.EMAIL_IS_INVALID)
      .required(ERRORS.EMAIL_IS_REQUIRED),
    phone: yup
      .string()
      .matches(PHONE_REGEX, {
        message: ERRORS.PHONE_IS_INVALID,
        excludeEmptyString: true,
      })
      .min(5, ERRORS.PHONE_IS_INVALID)
      .max(15, ERRORS.PHONE_IS_INVALID)
      .required(ERRORS.PHONE_IS_REQUIRED),
    message: yup
      .string()
      .max(1000, ERRORS.MESSAGE_IS_TOO_LONG)
      .required(ERRORS.MESSAGE_IS_REQUIRED),
  })
  .required();
